module.exports = __webpack_public_path__ + "ec0cf6043837bc4c3cf5c27738f36749.svg";